import { render } from "./OtiSquare.vue?vue&type=template&id=17773b44&scoped=true"
import script from "./OtiSquare.vue?vue&type=script&lang=js"
export * from "./OtiSquare.vue?vue&type=script&lang=js"

import "./OtiSquare.vue?vue&type=style&index=0&id=17773b44&lang=scss&scoped=true"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17773b44"]])

export default __exports__